<div class="container-fluid p-0">
  <div class="loading" id="loading" style="left:0px;">
    <div class="animation6">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>
  </div>

  <div class="page-title-box p-b-5 p-t-10">
    <div class="container">
      <div class="row align-items-center m-0">
        <div class="col-lg-6 col-sm-6 col-6">
          <h4 class="page-title bold">
            <figure class="text-left">
              <img style="margin-bottom: -5px" src="/img/sisgestour_white.png" alt="Sisgestour" width="185">
            </figure>
          </h4>
        </div>
        <div class="col-lg-6 col-sm-6 col-6">
          <ol class="breadcrumb float-right">
            <li class="breadcrumb-item">
              <button class="btn btn-outline-light m-b-5 w-100" routerLink="/admin/empresa/informacion"
                style="margin-top: -6px;">Admistración <i class="fas fa-cogs"></i></button>
            </li>
            <li class="breadcrumb-item active m-l-15">
              <span class="bold m-r-5 text-white hide-xs">{{user.name}}, </span>
              <a class="pointer text-white" (click)="logout()">
                <i class="fas fa-sign-out-alt"></i> Cerrar sesión
              </a>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="container">
    <ul class="nav nav-tabs m-t-10">
      <li class="nav-item" style="z-index: 1000;">
        <a class="nav-link active" >
          <i class="fas fa-building m-r-3"></i>Sucursales
        </a>
      </li>
      <li class="nav-item" style="z-index: 1000;">
        <a class="nav-link">
          <i class="fas fa-users-cog m-r-3"></i>Empleados
        </a>
      </li>
      <li class="nav-item" style="z-index: 1000;">
        <a class="nav-link">
          <i class="fas fa-lock m-r-3"></i>Usuarios
        </a>
      </li>
    </ul>
  </div> -->
  <div class="content m-t-30">
    <router-outlet></router-outlet>
  </div>

  <footer class="footer" style="left: 0; box-shadow: 0 -5px 15px -5px rgba(0, 0, 0, 0.2);">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="text-center d-sm-block text_footer">
            Copyright <a style="color: #001230;" href="https://sisgestour.com" target="_blank" class="bold">Sisgestour</a> &copy; 2026
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>
